(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/customer-service/assets/javascripts/models/common-questions.js') >= 0) return;  svs.modules.push('/modules/customer-service/assets/javascripts/models/common-questions.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.customer_service.models.CommonQuestions = Backbone.Model.extend({
    url: function() {
      if (svs.core.detect.feature('ft-customer-service-faq')) {
        var parentId = svs.customer_service.data.config.faqCommonQuestionsFolderId;
        return svs.core.jupiter.url() + new svs.content.shared.ContentUrlBuilder('basicfilter').addParams({ parentId: parentId, count: 100 }).build();
      }
      return svs.core.jupiter.url() + new svs.content.shared.ContentUrlBuilder('basicfilter').addParams({ contentType: 'cnt:faq', count: 100 }).build();

    },

    initialize: function() {
      var self = this,
        fetchOptions = {
          error: function(collection, response) {
            svs.customer_service_logger.error('Error in fetching faq: ' + JSON.stringify(response));
          }
        };

      if (svs.customer_service.data && svs.customer_service.data.faq && svs.customer_service.data.config.phone) {
        this.set('faq', svs.customer_service.data.faq);
        this.set('phone', svs.customer_service.data.config.phone);
      } else {
        this.fetch(fetchOptions);
      }

      self.set('messageSupport', svs.customer_service.data.config.messageSupport);
    },

    parse: function(response) {
      this.set('faq', response.result);
    }
  });
})(Backbone, _, svs);

 })(window);